import { Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, useTheme } from '@mui/material'
import React from 'react'
import { ShowOnlyToPayAmtCol, ShowOnlyToPayAmtSummaryCol } from '../../common/reportConstants'
import { getPaymentTypeBackground } from '../../../../common/helper'
import { useSelector } from 'react-redux'
import VirtualizedTable from '../../../../common/virtualisedTable'

const ShowOnlyToPayAmtTable = ({
  UseToPayAsCOD,
  loginData,
  selBranch,
  selDestCity,
  selFromBranch,
  tableData,
  reportType,
  summaryData,
  PymtTypeIntPresence,
  columnDefs,
  selectedFields,
  matchFields,
  summarySelectedFields,
  allownFormatLR,
}) => {
  const theme = useTheme()
  const { tableHeaderColor } = theme
  let updatedSummaryCols = []
  if (UseToPayAsCOD === 1) {
    updatedSummaryCols = ShowOnlyToPayAmtSummaryCol.map((col) => {
      if (col.field === '2') return { ...col, header: 'COD' }
      if (col.field === '7') return { ...col, header: 'COD (Manual)' }
      if (col.field === '9') return { ...col, header: 'COD (DDDV)' }
      return col
    }).filter((col) => col.field !== '4')
  }else{
    updatedSummaryCols =ShowOnlyToPayAmtSummaryCol
  }
  const updateTableData = tableData.map((row) => {
    return row.dataType === 'entry'
      ? {
          ...row,
          SenderName: (
            <Tooltip title={row.SenderName} placement="top-start">
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>{row.SenderName}</span>
            </Tooltip>
          ),
          SenderGSTN: (
            <Tooltip title={row.SenderGSTN} placement="top-start">
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>{row.SenderGSTN}</span>
            </Tooltip>
          ),
          RecName: (
            <Tooltip title={row.RecName} placement="top-start">
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>{row.RecName}</span>
            </Tooltip>
          ),
          ReceiverGSTN: (
            <Tooltip title={row.ReceiverGSTN} placement="top-start">
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                {row.ReceiverGSTN}
              </span>
            </Tooltip>
          ),
          ItemDetails: (
            <Tooltip title={row.ItemDetails} placement="top-start">
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                {row.ItemDetails}
              </span>
            </Tooltip>
          ),
          PaymentType: (
            <span
              style={{
                width: '150px',
                display: 'flex',
                padding: ' 4px 10px',
                alignItems: 'center',
                gap: '10px',
                whiteSpace: 'nowrap',
                verticalAlign: 'top',
                fontSize: '12px',
                color: '#444',
                fontWeight: '500',
                color: 'black',
                borderRadius: '13px',
                textAlign: 'left',
                backgroundColor: getPaymentTypeBackground(row.PaymentType),
              }}
            >
              {row.PaymentType}
            </span>
          ),
          Remarks: (
            <Tooltip title={row.Remarks} placement="top-start">
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>{row.Remarks}</span>
            </Tooltip>
          ),
        }
      : row
  })
  const headerContent = () => {
    return (
      <>
        <TableRow style={{ backgroundColor: '#bfe1ff', color: '#444444' }}>
          <TableCell
            className="reportTD"
            style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left', color: '#444444', height: '36px' }}
            colSpan={columnDefs.length - Math.floor(columnDefs.length / 3) * 2}
          >
            Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
          </TableCell>
          <TableCell
            className="reportTD"
            style={{ fontSize: '12px', fontWeight: '600', textAlign: 'center', color: '#444444' }}
            colSpan={Math.floor(columnDefs.length / 3)}
          >
            Destination City: {selDestCity?.name}
          </TableCell>

          <TableCell
            className="reportTD"
            style={{ fontSize: '12px', fontWeight: '600', textAlign: 'right', color: '#444444' }}
            colSpan={Math.floor(columnDefs.length / 3)}
          >
            Destination Branch: {selBranch?.name}
          </TableCell>
        </TableRow>
        <TableRow style={{ height: '47px' }}>
          {columnDefs.map((item) => {
            return (
              <TableCell
                style={{
                  ...item?.headerSx,
                  backgroundColor: '#e5f3ff',
                  color: '#444',
                  fontSize: '12px',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  fontWeight: '600',
                  whiteSpace: 'pre-line',
                }}
                colSpan={1}
              >
                {item?.header}
              </TableCell>
            )
          })}
        </TableRow>
      </>
    )
  }
  const bodyContent = (index, obj) => {
    return <DisPatchBody row={obj} index={index} tableHeaderColor={tableHeaderColor} columnDefs={columnDefs} />
  }
  return (
    <>
      <Stack
        sx={{ marginLeft: 2, marginRight: 2, height: 380, paddingTop: '10px', paddingBottom: '16px' }}
        className="vehicle-wise-table-box"
      >
        <VirtualizedTable
          tableData={updateTableData}
          headerContent={headerContent}
          rowContent={bodyContent}
          tableStyle={{ tableLayout: 'auto', width: '100%' }}
          autoResize={false}
        />
      </Stack>
      <Stack sx={{ marginLeft: 2, marginRight: 2, height: 480, paddingTop: '10px', paddingBottom: '16px' }}>
        <TableContainer sx={{ '&::-webkit-scrollbar': { width: '6px', height: '6px' } }} component={Paper} className="scrollBlue">
          <Table
            sx={{ marginRight: 2, paddingTop: '10px', marginTop: '30px', minWidth: '100%', borderTop: '1px solid #aeaeae' }}
            size="small"
            aria-label="a dense table"
          >
            <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
              <TableRow>
                <TableCell
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#444',
                    fontSize: '12px',
                    fontWeight: '600',
                    textAlign: 'center',
                    borderRight: '1px solid rgb(224,224,224,1)',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={2}
                  rowSpan={2}
                >
                  Vehicle Number
                </TableCell>
                {updatedSummaryCols.map((item) => {
                  return summarySelectedFields.hasOwnProperty(item?.field) || item?.field === '0' ? (
                    <TableCell
                      style={{
                        ...item?.headerSx,
                        backgroundColor: '#e5f3ff',
                        color: '#444',
                        fontSize: '12px',
                        lineheight: '16px',
                        letterspacing: '0.24px',
                        fontWeight: '600',
                        whiteSpace: 'pre-line',
                      }}
                      colSpan={2}
                    >
                      {item?.header}
                    </TableCell>
                  ) : null
                })}
              </TableRow>
              <TableRow>
                {updatedSummaryCols.map((item, index) => {
                  return summarySelectedFields.hasOwnProperty(item?.field) || item?.field === '0' ? (
                    <>
                      <TableCell
                        style={{
                          backgroundColor: '#e5f3ff',
                          color: '#444',
                          fontSize: '12px',
                          fontWeight: '600',
                          textAlign: 'right',
                          whiteSpace: 'nowrap',
                        }}
                        colSpan={1}
                      >
                        {index === updatedSummaryCols.length - 1 ? ' Totals Units' : 'Units'}
                      </TableCell>
                      <TableCell
                        style={{
                          backgroundColor: '#e5f3ff',
                          color: '#444',
                          fontSize: '12px',
                          fontWeight: '600',
                          textAlign: 'right',
                          whiteSpace: 'nowrap',
                        }}
                        colSpan={1}
                      >
                        {index === updatedSummaryCols.length - 1 ? 'Totals Amount' : 'Amount'}
                      </TableCell>
                    </>
                  ) : null
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {summaryData.length > 0 &&
                summaryData.map((row, index, itSelfArray) => {
                  return (
                    <TableRow>
                      <TableCell
                        style={{
                          minHeight: '36px',
                          fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                          backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                          whiteSpace: 'pre',
                          textAlign: 'left',
                          fontSize: '12px',
                          color: '#444',
                        }}
                        colSpan={2}
                      >
                        {row.vehicleNo}
                      </TableCell>
                      {summarySelectedFields.hasOwnProperty('1') && (
                        <>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row.paidQuantity}
                          </TableCell>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row.paidAmount}
                          </TableCell>
                        </>
                      )}
                      {summarySelectedFields.hasOwnProperty('2') && (
                        <>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row.toPayQuantity}
                          </TableCell>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row.toPayAmount}
                          </TableCell>
                        </>
                      )}
                      {summarySelectedFields.hasOwnProperty('3') && (
                        <>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row.fOCQuantity}
                          </TableCell>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row.fOCAmount}
                          </TableCell>
                        </>
                      )}
                      {summarySelectedFields.hasOwnProperty('4') && (
                        <>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row.cODQuantity}
                          </TableCell>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row.cODAmount}
                          </TableCell>
                        </>
                      )}
                      {summarySelectedFields.hasOwnProperty('5') && (
                        <>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row.onAccountQuantity}
                          </TableCell>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row.onAccountAmount}
                          </TableCell>
                        </>
                      )}
                      {summarySelectedFields.hasOwnProperty('6') && (
                        <>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row['paid(Manual)Quantity']}
                          </TableCell>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row['paid(Manual)Amount']}
                          </TableCell>
                        </>
                      )}
                      {summarySelectedFields.hasOwnProperty('7') && (
                        <>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row['toPay(Manual)Quantity']}
                          </TableCell>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row['toPay(Manual)Amount']}
                          </TableCell>
                        </>
                      )}
                      {summarySelectedFields.hasOwnProperty('8') && (
                        <>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row.selfQuantity}
                          </TableCell>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row.selfAmount}
                          </TableCell>
                        </>
                      )}
                      {summarySelectedFields.hasOwnProperty('9') && (
                        <>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row['toPay(DDDV)Quantity']}
                          </TableCell>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row['toPay(DDDV)Amount']}
                          </TableCell>
                        </>
                      )}
                      {summarySelectedFields.hasOwnProperty('10') && (
                        <>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row['onAccount(Manual)Quantity']}
                          </TableCell>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row['onAccount(Manual)Amount']}
                          </TableCell>
                        </>
                      )}
                      {summarySelectedFields.hasOwnProperty('11') && (
                        <>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row.totalUnits}
                          </TableCell>
                          <TableCell
                            style={{
                              minHeight: '36px',
                              fontWeight: itSelfArray.length - 1 === index ? '600' : '500',
                              backgroundColor: itSelfArray.length - 1 === index ? '#EEE' : '',
                              whiteSpace: 'pre',
                              textAlign: 'right',
                              fontSize: '12px',
                              color: '#444',
                            }}
                          >
                            {row.totalAmount}
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                  )
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </>
  )
}
const DisPatchBody = ({ row, index, tableHeaderColor, columnDefs }) => {
  if (!row?.dataType) return null
  const getStyles = (field, align) => {
    const common = {
      minHeight: '36px',
      fontSize: '12px',
      color: '#444',
    }
    if (row.dataType === 'entry') {
      return {
        ...common,
        fontWeight: '500',
        textAlign: align || 'left',
        height: '36px',
      }
    }
    if (row.dataType === 'subHeader') {
      return {
        ...common,
        fontWeight: '600',
        backgroundColor: tableHeaderColor?.isSubHeadingColor,
        textAlign: row.align?.[field] || 'left',
        position: 'sticky',
        top: '94px',
      }
    }
    if (row.dataType === 'total') {
      return {
        ...common,
        fontWeight: '600',
        backgroundColor: tableHeaderColor?.isTotalColor,
        textAlign: row.align?.[field] || 'right',
      }
    }
  }

  return (
    <>
      {(() => {
        let skip = 0

        return columnDefs.map((item, i) => {
          if (skip > 0) {
            skip--
            return null
          }
          const colSpan = row.colSpan?.[item.field] || 1
          skip = colSpan - 1
          return (
            <TableCell className="reportTD" key={item.field + i + index} colSpan={colSpan} style={getStyles(item.field, item.textAlign)}>
              {row[item.field]}
            </TableCell>
          )
        })
      })()}
    </>
  )
}
export default ShowOnlyToPayAmtTable